import { ISvcStatusBadge } from '@solvace/component/svc-status-badge';
import { CategorizedDrillDown } from '@solvace/core/models';
import { SvcPage } from 'projects/lib-shared-core/src/lib/interfaces/svc-page.interface';

export interface ActionPlanDrillDownItem {
  actionPlanId: number;
  actionPlanUniqueId: number;
  actionPlanName: string;
  createDate: Date;
  status: number;
  isPrivate: boolean;
  owners: ActionPlanDrilldownOwner[];
  deadline: string;
}

export interface ActionPlanDrilldownOwner {
  userId: string;
  userName: string;
  pictureFile: string;
}

export class ActionPlanCategorizedDrillDown implements CategorizedDrillDown<ActionPlanDrillDownItem> {
  indicatorEnum: number;
  indicatorItems: ActionPlanDrillDownItem[];
}

export enum ActionPlanDrillDownStatus {
  COMPLETED = 40,
  IN_APPROVAL = 30,
  ON_TIME = 20,
  DELAYED = 10,
  CANCELLED = 50,
}

export const ActionPlanDrillDownStatusBadge = <ActionPlanDrillDownStatus>(enumDefinition: ActionPlanDrillDownStatus): ISvcStatusBadge => {
  switch (enumDefinition) {
    case ActionPlanDrillDownStatus.COMPLETED:
      return { description: 'Cumprido', type: 'completed' };
    case ActionPlanDrillDownStatus.IN_APPROVAL:
      return { description: 'Em Aprovação', type: 'approval' };
    case ActionPlanDrillDownStatus.ON_TIME:
      return { description: 'No Prazo', type: 'ontime' };
    case ActionPlanDrillDownStatus.DELAYED:
      return { description: 'Atrasado', type: 'delayed' };
  }
};

export const ActionplanStatusBadgeByText = (text: string): ISvcStatusBadge => {
  const normalized = `${text ?? ''}`.normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();
  switch (normalized) {
    case 'concluido':
    case 'cumprido':
    case 'completed':
    case 'finalizado':
      return { description: text, type: 'completed' };
    case 'em aprovacao':
    case 'in approval':
      return { description: text, type: 'approval' };
    case 'no prazo':
    case 'on time':
      return { description: text, type: 'ontime' };
    case 'atrasado':
    case 'delayed':
      return { description: text, type: 'delayed' };
    case 'cancelado':
    case 'canceled':
      return { description: text, type: 'closed' };
    default:
      return text ? { description: text, type: 'ontime' } : undefined;
  }
};

export interface ActionplanAnalyticsDrilldown {
  actionPlans: ActionplanAnalytics[];
  page: SvcPage;
}

export interface ActionplanAnalytics {
  planId: number;
  planName: string;
  statusName: string;
  registerId: number;
  statusBadge?: ISvcStatusBadge;
  /** AB#76014 — `GET /Analytics/drilldown` returns the due date and the responsible since 16/10/2026 (revamp-ActionPlan `DrillDownQueryResponse`). */
  actualPrevisionDate?: string | null;
  /** `ActionPlanDrillDownStatus` of the row; announced by the backend on 20/10/2026, optional until it ships. */
  statusId?: number | null;
  responsibleUserId?: string | null;
  responsibleName?: string | null;
  /** Signed picture URL; null when the user has no picture. */
  responsiblePicture?: string | null;
  responsibleInitialsColor?: string | null;
  /** AB#77377 — `GET /Analytics/drilldown` returns the plan dates since 29/10/2026; the age row counts from `creationDate`. */
  creationDate?: string | null;
  conclusionDate?: string | null;
}
